import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import tw from 'twin.macro';
import { TrashIcon } from '@heroicons/react/24/solid';

import { BaseModal, ButtonV2, Title } from '@restworld/ui-ds';

interface DeleteJobPositionDraftModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function DeleteJobPositionDraftModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: DeleteJobPositionDraftModalProps) {
  const { t } = useTranslation('job-positions-page');

  const handleConfirm = useCallback(() => {
    onConfirm();
  }, [onConfirm]);

  const titleEl = (
    <Title
      content={t('delete_draft_confirmation_title')}
      fontSize="extraLarge"
      fontWeight="semibold"
      textColor="neutral-700"
      twStyle={tw`text-center leading-[30px] px-4 sm:px-0`}
    />
  );

  const footerEl = (
    <div tw="flex flex-col justify-center items-center gap-4 w-full">
      <ButtonV2
        onClick={handleConfirm}
        fullwidth
        loading={isLoading}
        StartIcon={TrashIcon}
        variant="secondary-danger"
        disabled={isLoading}
      >
        {t('delete_draft_confirm_button')}
      </ButtonV2>
      <ButtonV2 variant="tertiary" fullwidth onClick={() => onClose()} disabled={isLoading}>
        {t('delete_draft_cancel_button')}
      </ButtonV2>
    </div>
  );

  return (
    <BaseModal
      showMobileGestures
      modalStyles={[tw`w-full max-w-[640px] lg:(max-w-screen-sm)`]}
      open={isOpen}
      onClose={() => onClose()}
      title={titleEl}
      footer={footerEl}
    >
      <div tw="flex flex-col justify-center items-center gap-5 w-full text-center mt-6">
        <Title
          content={t('delete_draft_confirmation_description')}
          fontSize="base"
          fontWeight="medium"
          textColor="neutral-700"
          twStyle={tw`whitespace-pre-line`}
        />
      </div>
    </BaseModal>
  );
}

export default DeleteJobPositionDraftModal;
